<template>
    <form @submit.prevent="submit">
        <form-input type="text" id="searchphrase" placeholder="Suchwort" label="Portalsuche" v-model="form.searchphrase" :error="form.errors.searchphrase" @keyup.enter="submit" @cleared="redirect" autocomplete="off"/>
    </form>
</template>

<script>
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';

export default {
    name: 'SearchInput',
    components: {FormInput},
    props: {},
    data() {
        const form = useForm({
            'searchphrase': null,
        });
        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                   ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('portal-search.post'), {});
        },
        redirect() {
            if (this.$route().current() === 'admin.portal-search')
                this.$inertia.visit(this.$$route('dashboard'), );
        }
    }
};
</script>
